/**
 * Docebo Search Object model is the base object for both Subscription and Courses
 */
export class SearchObject {
  constructor(
    public parentId: number, // Parent subscription id for courses, else -1 for Subscriptions
    public parentSlug: string, // Parent subscription slug for courses, else empty string for Subscriptions
    public id: number, // Can be a subscription id or course id
    public name: string,
    public code: string,
    public description: string,
    public courseDuration: string | number,
    public courseDurationMins: string | number,
    public type: string, // course : elearning , subscription ; learning_plan
    public slug: string,
    public instructionType: string, // Need this to determine Certification Exam, Self-Study, Instructor-Led, eLearning
    public relatedCourseIds?: number[],
    public parentSubscriptionIds?: number[], // Courses having more than one Subscriptions
    public isFreeCourse?: boolean // Courses are free regardless of subscription if add b
  ) {}
}
